export type RegisterRace = 'chinese' | 'european';

export interface RegisterSkillOption {
  skill: string;
  type: 'weapon' | 'buff' | 'essence' | 'force';
  label: string;
  img: string;
  focusImg: string;
  fixed?: boolean;
}

export interface RegisterSkillsSelection {
  weapon?: string;
  buff?: string;
  essence?: string;
  force?: string;
}

const EU_BASE = '/assets/images/icon/skillmastery/europe';
const CN_BASE = '/assets/images/icon/skillmastery/china';

function euSkill(skill: string, label: string, type: 'weapon' | 'buff'): RegisterSkillOption {
  return {
    skill,
    type,
    label,
    img: `${EU_BASE}/eu_${skill}.webp`,
    focusImg: `${EU_BASE}/eu_${skill}_focus.webp`,
  };
}

function cnWeapon(skill: string, label: string): RegisterSkillOption {
  return {
    skill,
    type: 'weapon',
    label,
    img: `${CN_BASE}/mastery_${skill}.webp`,
    focusImg: `${CN_BASE}/mastery_${skill}_focus.webp`,
  };
}

export const EUROPEAN_SKILLS: RegisterSkillOption[] = [
  euSkill('rog', 'Rogue', 'weapon'),
  euSkill('wizard', 'Wizard', 'weapon'),
  euSkill('warrior', 'Warrior', 'weapon'),
  euSkill('bard', 'Bard', 'buff'),
  euSkill('cleric', 'Cleric', 'buff'),
  euSkill('warlock', 'Warlock', 'buff'),
];

export const CHINESE_WEAPONS: RegisterSkillOption[] = [
  cnWeapon('bow', 'Bow'),
  cnWeapon('sword', 'Sword'),
  cnWeapon('spear', 'Spear'),
];

export const CHINESE_FIXED_SKILLS: RegisterSkillOption[] = [
  {
    skill: 'gigong',
    type: 'essence',
    label: 'Gigong',
    img: `${CN_BASE}/mastery_gigong_focus.webp`,
    focusImg: `${CN_BASE}/mastery_gigong_focus.webp`,
    fixed: true,
  },
  {
    skill: 'water',
    type: 'force',
    label: 'Water',
    img: `${CN_BASE}/mastery_water_focus.webp`,
    focusImg: `${CN_BASE}/mastery_water_focus.webp`,
    fixed: true,
  },
];

export function getDefaultChineseSkills(): RegisterSkillsSelection {
  return { essence: 'gigong', force: 'water' };
}
